// test475
(475 && 0);
